import { render } from "./GoalsnPerformance.vue?vue&type=template&id=e1ba68ee&scoped=true"
import script from "./GoalsnPerformance.vue?vue&type=script&lang=js"
export * from "./GoalsnPerformance.vue?vue&type=script&lang=js"

import "./GoalsnPerformance.vue?vue&type=style&index=0&id=e1ba68ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1ba68ee"]])

export default __exports__